import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../../config/firebase-config";

interface PremiumDesigner {
  id: string;
  name: string;
  description: string;
  avatar: string;
  username: string;
}

export const DesignerService = {
  async getPremiumDesigners(limitCount: number = 5): Promise<PremiumDesigner[]> {
    try {
      // Query without orderBy to avoid composite index requirement
      const q = query(
        collection(db, "creator-profiles-summary"),
        where("isSubscribed", "==", true)
      );
      
      const snapshot = await getDocs(q);
      const designers = snapshot.docs
        .map(doc => ({
          id: doc.id,
          name: doc.data().name || '',
          description: doc.data().occupation || '',
          avatar: doc.data().profilePicture || '/favicon.svg',
          username: doc.id,
          creationTime: doc.data().creationTime?.seconds || 0
        }))
        // Sort by creation time in memory (newest first)
        .sort((a, b) => b.creationTime - a.creationTime)
        // Limit results
        .slice(0, limitCount)
        // Remove creationTime from returned objects
        .map(({ creationTime, ...designer }) => designer);
      
      return designers;
    } catch (error) {
      console.error('Error fetching premium designers:', error);
      throw error;
    }
  }
};
